export default __webpack_public_path__ + "static/media/install.8c12a7c7.png";